import { route } from '../../route/Index';
import { IProject } from '../../shared/iProject';
import { redux } from '../../store';
import { setProject } from '../../store/project/projectSlice';
import ProjectProvider from './projectProvider';

export const getProjectPreviewAsync = ProjectProvider.getProjectPreviewAsync;

export const createProjectAsync = ProjectProvider.createProjectAsync;

export const getProjectAsync = ProjectProvider.getProjectAsync;

export const getProjectTemplatesAsync = ProjectProvider.getProjectTemplatesAsync;

export const deleteProjectAsync = ProjectProvider.deleteProjectAsync;

const createFromExistingProjectAsync = ProjectProvider.createFromExistingProjectAsync;

export const updateProjectAsync = ProjectProvider.updateProjectAsync;

export const composeProjectAsync = ProjectProvider.composeProjectAsync;

export const saveProjectAsync = async (project: IProject) => {
    const user = redux.getState().user;
    if (project.projectInfo?.authorEmail === user.data?.email) {
        let payload: IProject = { ...project };
        delete payload.phaseOneOutputs;
        let resUpdate = await updateProjectAsync(payload);
        resUpdate.data.phaseOneOutputs = project.phaseOneOutputs;
        redux.dispatch(setProject(resUpdate.data));
        return resUpdate;
    } else {
        let res = await createFromExistingProjectAsync(project, user.data?.email! );
        window.location.href = window.location.origin + route.design.replace(':projectId', res.data!.id!.toString()) + '?withCalculation=true';
    }
};
